import axios from 'axios';

import {
    GET_JOBTYPE_REQUEST, GET_JOBTYPE_SUCCESS, GET_JOBTYPE_FAIL, CREATE_JOBTYPE_REQUEST, CREATE_JOBTYPE_SUCCESS, CREATE_JOBTYPE_FAIL, EDIT_JOBTYPE_REQUEST, EDIT_JOBTYPE_SUCCESS, EDIT_JOBTYPE_FAIL, DELETE_JOBTYPE_REQUEST, DELETE_JOBTYPE_SUCCESS, DELETE_JOBTYPE_FAIL, DELETE_JOBTYPE_RESET, EDIT_JOBTYPE_RESET, CREATE_JOBTYPE_RESET, START_JOB_REQUEST, START_JOB_SUCCESS, START_JOB_FAIL, GET_JOBS_REQUEST, GET_JOBS_SUCCESS, GET_JOBS_FAIL, START_JOB_RESET
} from '../constants/jobConstants';

export const getJobTypes = () => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_JOBTYPE_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/jobs/types`, config);

        dispatch({
            type: GET_JOBTYPE_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: GET_JOBTYPE_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const createNewJobType = (name) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: CREATE_JOBTYPE_REQUEST,
        });

        const formData = {
            name
        }

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/jobs/types`, formData, config);

        dispatch({
            type: CREATE_JOBTYPE_SUCCESS,
            payload: data
        });
        dispatch({
            type: CREATE_JOBTYPE_RESET
        })
    } catch (error) {
        dispatch({
            type: CREATE_JOBTYPE_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const editExistingJobType = (id, name) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();


        dispatch({
            type: EDIT_JOBTYPE_REQUEST,
        });

        const formData = {
            name
        }

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`,
                'Content-type': 'application/json'
            },
        };

        const { data } = await axios.put(`${process.env.REACT_APP_BACKEND_URI}/jobs/types/${id}`, formData, config);

        dispatch({
            type: EDIT_JOBTYPE_SUCCESS,
            payload: data
        });
        dispatch({
            type: EDIT_JOBTYPE_RESET
        })
    } catch (error) {
        dispatch({
            type: EDIT_JOBTYPE_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const deleteExistingJobType = (id) => async (dispatch, getState) => {

    try {
        const { userAccess } = getState();

        dispatch({
            type: DELETE_JOBTYPE_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.delete(`${process.env.REACT_APP_BACKEND_URI}/jobs/types/${id}`, config);

        dispatch({
            type: DELETE_JOBTYPE_SUCCESS,
            payload: data
        });

        dispatch({
            type: DELETE_JOBTYPE_RESET
        })
    } catch (error) {
        dispatch({
            type: DELETE_JOBTYPE_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const startNewJob = (vehicle, jobType, currentMileage) => async (dispatch, getState) => {

    try {
        const { userAccess } = getState();

        dispatch({
            type: START_JOB_REQUEST,
        });

        const formData = {
            vehicle,
            jobCard: {
                "completed": false,
                jobType,
                currentMileage
            }
        }

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`,
                'Content-Type': 'application/json'
            },
        };

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/jobs/card/start`, formData, config);

        dispatch({
            type: START_JOB_SUCCESS,
            payload: data
        });

        dispatch({
            type: START_JOB_RESET
        })


    } catch (error) {
        dispatch({
            type: START_JOB_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const getAllJobs = () => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_JOBS_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/jobs/pending`, config);

        dispatch({
            type: GET_JOBS_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: GET_JOBS_FAIL,
            payload: 'An error Occurred'
        });
    }
};